import * as React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Button } from "./button";

interface TimePickerProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  error?: boolean;
}

export const TimePicker: React.FC<TimePickerProps> = ({
  value,
  onChange,
  className,
  error,
}) => {
  const [open, setOpen] = React.useState(false);

  // Genera opciones de tiempo cada 15 minutos
  const times = Array.from({ length: 24 * 4 }, (_, i) => {
    const h = Math.floor(i / 4)
      .toString()
      .padStart(2, "0");
    const m = ((i % 4) * 15).toString().padStart(2, "0");
    return `${h}:${m}`;
  });

  // Cierra el popover al seleccionar una hora
  const handleSelect = (t: string) => {
    onChange(t);
    setOpen(false);
  };

  return (
    <div className="relative w-full">
      <Popover open={open} onOpenChange={setOpen} fullWidth>
        <PopoverTrigger asChild>
          <Button
            
            type='button'
            variant="outline"
            className={`w-full justify-start font-normal ${error ? "border-red-500" : ""} ${className || ""}`}
            onClick={() => setOpen((prev) => !prev)}
          >
            {value || "Select time"}
          </Button>
        </PopoverTrigger>
        {open && (
          <PopoverContent className="absolute left-0 top-full p-2 max-h-64 overflow-y-auto w-40 bg-white border rounded shadow-lg z-50">
            <div className="grid grid-cols-2 gap-1">
              {times.map((t) => (
                <Button
                  type='button'
                  key={t}
                  variant="ghost"
                  className="w-full justify-start"
                  onClick={() => handleSelect(t)}
                >
                  {t}
                </Button>
              ))}
            </div>
          </PopoverContent>
        )}
      </Popover>
    </div>
  );
};